<section class="w-screen md:w-auto md:min-w-[30rem] rounded-lg bg-base-100">
  <div class="flex flex-col gap-4 p-4">
    <lepi-color-picker [(cpColor)]="eventForm.color().value" />
    <fieldset class="fieldset">
      <legend class="fieldset-legend">제목</legend>
      <input
        lepiInput
        [field]="eventForm.title"
        class="input focus-within:border-primary w-full"
        placeholder="제목을 입력해주세요." />
      @if (eventForm.title().touched() && eventForm.title().invalid()) {
        <p class="text-xs text-error">
          {{ eventForm.title().errors()[0]?.message }}
        </p>
      }
    </fieldset>
    <div class="flex flex-col gap-2 w-full">
      <div class="flex w-full justify-between items-center">
        <fieldset class="fieldset w-full">
          <div class="flex w-full justify-between items-center">
            <legend class="fieldset-legend">날짜</legend>
            <label class="fieldset-label">
              <input
                type="checkbox"
                [field]="eventForm.hasEndDate"
                class="rounded checkbox checkbox-primary border-base-content/20" />
              <p class="text-sm">종료일 포함</p>
            </label>
          </div>
          <div class="flex gap-2 items-center">
            @if (hasTime()) {
              <lepi-checkbox [field]="eventForm.allDay" label="종일" />
            }
          </div>
        </fieldset>
      </div>
      <div class="flex md:flex-row flex-col gap-2.5 md:items-center">
        <lepi-date-picker [field]="eventForm.startDate" />
        @if (hasTime() && !allDay()) {
          <input lepiInput type="time" [field]="eventForm.startTime" class="w-full input" />
        }
        @if (hasEndDate()) {
          <p class="theme-text">-</p>
          <lepi-date-picker [field]="eventForm.endDate" />
          @if (hasTime() && !allDay()) {
            <input lepiInput type="time" [field]="eventForm.endTime" class="w-full input" />
          }
        }
      </div>
    </div>
    <fieldset class="fieldset">
      <legend class="fieldset-legend">내용</legend>
      <textarea
        lepiInput
        [field]="eventForm.content"
        class="textarea resize-none focus-within:border-primary"
        placeholder="내용을 입력해주세요."></textarea>
    </fieldset>
  </div>
  <div class="w-full h-px bg-base-300"></div>
  <div class="flex w-full p-4">
    <button (click)="submit()" class="btn-block btn btn-primary" [disabled]="eventForm().invalid()">
      {{ event() ? '수정' : '등록' }}
    </button>
  </div>
</section>
